import controller from './header-core.controller';
import templateAD from './templates/header-adaptative.html';
import templateT1 from './templates/header-core-t1.view.html';

let HeaderCoreComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};


function changeTemplate() {
    if (__env.adaptative) {
        return templateAD;
    } else {
        return templateT1
    }
}


export default HeaderCoreComponent;



/** WEBPACK FOOTER **
 ** ./www/components/header-core/header-core.component.js
 **/